import React, { useState } from "react";
import { Link, Outlet, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import "../index.css";
import Header from "../components/Header";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
function Pokemon(pokemon) {
  // ! Detect witch pokemon's page is this page
  let location = useLocation();
  let path = location.pathname;
  const length = path.length;
  let Pokemon = path.replace("/pokemon/", "");
  // Type coloring variable
  const [typeColor, setTypeColor] = useState("");

  // * Variable for Pokemon API DATA
  const [image, setImage] = useState("");
  const [type, setType] = useState("");
  const [move, setMove] = useState("");
  const [HP, setHP] = useState("");
  const [Attack, setAttack] = useState("");
  const [Defence, setDefence] = useState("");
  const [Special_attack, setSpecial_attack] = useState("");
  const [Special_Defence, setSpecial_Defence] = useState("");
  const [Speed, setSpeed] = useState("");
  const [totalStat, setTotalStat] = useState("");
  //? Poke API
  async function getData() {
    let data = await axios.get(`https://pokeapi.co/api/v2/pokemon/${Pokemon}`);
    console.log(data);
    let URL = data.data;
    let Stat = data.data.stats;
    setImage(URL.sprites.front_default);
    setType(URL.types[0].type.name);
    setHP(Stat[0].base_stat);
    setAttack(Stat[1].base_stat);
    setDefence(Stat[2].base_stat);
    setSpecial_attack(Stat[3].base_stat);
    setSpecial_Defence(Stat[4].base_stat);
    setSpeed(Stat[5].base_stat);
    setTotalStat(
      HP + Attack + Defence + Special_attack + Special_Defence + Speed
    );
  }

  getData();

  return (
    <div>
      <Header />
      <br />
      <div className="container wrap ">
        <h1 className="title" style={{ textAlign: "center" }}>
          {Pokemon}
        </h1>
        <div
          className="flex jcenter center row container"
          style={{
            textAlign: "center",
            justifyContent: "center",
            flex: 1,
            marginLeft: "40%",
          }}
        >
          <div className=" col">
            <img
              src={`${image}`}
              alt={`${Pokemon}`}
              style={{ maxWidth: "200px", maxHeight: "200px" }}
            />
            <h3>Type</h3>
            <p>{`${type}`}</p>
          </div>
          <div className="flex  center col " style={{ marginLeft: "5%" }}>
            <TableContainer sx={{ maxWidth: 250 }} component={Paper}>
              <Table aria-label="stat table">
                <TableHead>
                  <TableRow>
                    <TableCell>Status</TableCell>
                    <TableCell>Base stat</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>HP</TableCell>
                    <TableCell>{`${HP}`}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Attack</TableCell>
                    <TableCell>{`${Attack}`}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Defence</TableCell>
                    <TableCell>{`${Defence}`}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Special Attack</TableCell>
                    <TableCell>{`${Special_attack}`}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Special Defence</TableCell>
                    <TableCell>{`${Special_Defence}`}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Speed</TableCell>
                    <TableCell>{`${Speed}`}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell>Total</TableCell>
                    <TableCell>{`${totalStat}`}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Pokemon;
